import { useAttrs, computed } from 'vue';

export const useQaLocators = (componentName: string) => {
  const qaLocator = computed((): string => {
    const attrs = useAttrs();
    return attrs['qa-locator-id'] ? `${attrs['qa-locator-id']}` : `${componentName}`;
  });

  function set(name?: string) {
    return name ? `${qaLocator.value}-${name}` : qaLocator.value;
  }

  return {
    set,
  };
};
